import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, LANGUAGE_NAMES } from './i18n';
import './LanguageSwitcher.css';

// A dropdown that switches the UI language. It changes the active language (which
// i18next persists to localStorage via its detector) and, optionally, notifies the
// caller through `onChange` so an authenticated screen can also persist the choice
// to the user's profile.
//
// Reused in two places: the anonymous Login/Register pages (no `onChange`, so the
// choice only lives locally until the user logs in), and the settings overlay
// (which passes `onChange` to save the preferred language to the backend).
function LanguageSwitcher({ onChange, disabled }) {
  const { i18n, t } = useTranslation();

  // i18n.language may carry a region (e.g. "en-GB"); reduce it to the base code so
  // the matching <option> is selected.
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  const handleChange = (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    if (onChange) {
      onChange(language);
    }
  };

  return (
    <select
      className="language-select"
      value={current}
      onChange={handleChange}
      disabled={disabled}
      aria-label={t('language.label')}
    >
      {SUPPORTED_LANGUAGES.map((language) => (
        <option key={language} value={language}>
          {LANGUAGE_NAMES[language]}
        </option>
      ))}
    </select>
  );
}

export default LanguageSwitcher;
